var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"container"},[_c('h2',[_vm._v("Histórico de Solicitações")]),_c('div',{staticClass:"historico-licencas"},[(_vm.historicos.length)?_vm._l((_vm.historicos),function(historico,index){return _c('HistoricoCard',{key:index,attrs:{"data":historico}})}):_c('p',[_vm._v("Nenhum histórico encontrado.")])],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }